import React, { useEffect } from 'react';
import { ArrowLeft } from '@components/Common/Icons';
import styles from './styles.module.scss';
import cN from 'classnames';

interface I_SlidePage {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
    title: string;
    children: JSX.Element;
    isHeaderShow?: boolean;
}

const SlidePage: React.FC<I_SlidePage> = ({
    visible,
    children,
    title,
    setIsVisible,
    isHeaderShow = true,
}) => {
    useEffect(() => {
        const body = document.querySelector('body');
        const html = document.querySelector('html');
        if (!body || !html) return;
        if (visible) {
            html.style.overflow = 'hidden';
            body.style.overflow = 'hidden';
        } else {
            html.style.overflow = '';
            body.style.overflow = '';
        }
    }, [visible]);

    return (
        <div className={cN(styles.slidePage, styles[visible ? 'open' : ''])}>
            {isHeaderShow && (
                <div className={styles.header}>
                    <div className={styles.goBack} onClick={() => setIsVisible(false)}>
                        <ArrowLeft fill="#669" />
                    </div>
                    <div className={styles.title}>{title}</div>
                </div>
            )}
            <div className={cN(styles.content, 'contentBox')}>{children}</div>
        </div>
    );
};

export default SlidePage;
